import { UserGroupCarRole, type CarOwnerRecord } from '@navio/nsdk';

type LeasedCar = {
  isLeased: boolean;
  /** Owning company, when a current OWNER row has a name. */
  leasingCompanyName?: string;
  /** Owner names, omitting the company already shown on the leased badge. */
  otherOwnerNames: string | null;
};

export const leasedCarFromOwners = (owners?: CarOwnerRecord[] | null): LeasedCar => {
  const rows = owners ?? [];
  const leasingCompanyName = rows.find((owner) => owner.role === UserGroupCarRole.OWNER)?.userGroup.name;
  const isLeased = rows.some((owner) => owner.role === UserGroupCarRole.LEASEHOLDER);
  // The owning company is already shown on the leased badge, so drop it from the plain owner list.
  const isOwnerShownOnBadge = (owner: CarOwnerRecord) =>
    isLeased && leasingCompanyName != null && owner.role === UserGroupCarRole.OWNER;
  const otherOwnerNames =
    rows
      .filter((owner) => !isOwnerShownOnBadge(owner))
      .map((owner) => owner.userGroup.name)
      .filter(Boolean)
      .join(', ') || null;

  return { isLeased, leasingCompanyName, otherOwnerNames };
};
